import React, { useState } from 'react'
import MyAppBar from '../MyAppBar'
import CircleOfFifths from './CircleOfFifths'

import Scale from '@tonaljs/scale'
import Chord from '@tonaljs/chord'
import Note from '@tonaljs/note'
import ScaleType from '@tonaljs/scale-type'
import ChordDetect from '@tonaljs/chord-detect'

import { notes } from '../util/TonalUtils'
import ChordCard from '../ChordCard'
import ToneSound from '../ToneSound'
import { notesToChord } from '../util/ToneUtils'
import { Button } from '@material-ui/core'
import ChordProgressionEditor from './ChordProgressionEditor'

// const modesNames = Scale.modeNames('C major').map(modeName => modeName[1])// TODO : update modeName to full modeName (minor/major/etc) or only major / minor
const modesNames = ['major', 'minor']

const chordProgressions = [
	[1, 4, 5, 1]
]

// console.log({ modesNames })

const getRandomScale = () => {
	return Scale.get(notes[Math.round(Math.random() * (notes.length - 1))] + ' ' + modesNames[Math.round(Math.random() * (modesNames.length - 1))])
}

const getChords = (scale: any): any[] => {

	const degrees = chordProgressions[Math.round(Math.random() * (chordProgressions.length - 1))]

	const modesNames = Scale.modeNames(scale.name)

	const scales: any[] = []

	degrees.forEach((d) => scales.push(Scale.get(modesNames[d - 1][0] + ' ' + modesNames[d - 1][1])))

	// const chordsNames = scales.map((scale: any) => {
	// 	const chordsNames = Scale.scaleChords(scale.name)

	// 	return chordsNames[Math.round(Math.random() * (chordsNames.length - 1))]
	// })
	
	// const chords = chordsNames.map((chordName: any, i: number) => Chord.get(scale.notes[degrees[i]] + chordName))

	// console.log('getChords: ', { scales, chordsNames, chords })

	const chordsDetects = scales.map((scale: any) => {
		const notes = [scale.notes[0], scale.notes[2], scale.notes[4]]

		if (Math.random() > 0.7)
			notes.push(scale.notes[6])

		return ChordDetect.detect(notes)
	})

	const chords = chordsDetects.map((chordsDetect: any) => Chord.get(chordsDetect[0]))

	// console.log('getChords: ', { scales, chords, chordsDetects })

	return chords
}

const initialScale = getRandomScale()
const initialChords = getChords(initialScale)

const ChordProgressionGenerator = (props: {
	settings: any,
	onSettingsChange: (settings: any) => void,
	constants: any,
	setTitle: (title: string) => void
}) => {
	const {
		settings,
		onSettingsChange,
		constants,
		setTitle
	} = props

	const [scale, setScale] = useState(initialScale)
	const [chords, setChords] = useState(initialChords)

	const handleGenerate = () => {
		const scale = getRandomScale()
		const chords = getChords(scale)

		setScale(scale)
		setChords(chords)
	}
	
	return (
		<div id='chord-progression-generator'>
			
			<MyAppBar
        constants={constants}
        onSettingsChange={onSettingsChange}
        settings={settings}
      />

			<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
			
				<CircleOfFifths
					scale={{}}
					onChange={() => null}
				/>

				<ChordProgressionEditor
					chords={chords}
					onPlayClick={(c) => ToneSound.playNotes(notesToChord(c.notes), settings.sound)}
					onChange={() => null}
				/>

				<div style={{ display: 'flex' }}>
					<Button onClick={handleGenerate}>
						Generate
					</Button>

				</div>

			</div>

		</div>
	)
}

export default ChordProgressionGenerator
